import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { CheckCircle, Copy, Check, MessageSquare, Smartphone, FileText, AlertCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TwilioCompliancePage() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen w-full bg-background p-4 sm:p-6 md:p-8 flex flex-col items-center overflow-x-hidden" data-id="element-1808">
      <div className="max-w-3xl w-full mx-auto" data-id="element-1809">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-1810">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-1811" />
        </div>
        <header className="text-center mb-8" data-id="element-1812">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1813">
            <span className="text-primary" data-id="element-1814">ScribeTok</span> SMS Service
          </h1>
          <p className="text-lg text-muted-foreground" data-id="element-1815">
            Terms of Use & Service Information
          </p>
        </header>
        <Card className="mb-8" data-id="element-1816">
          <CardContent className="p-6 md:p-8" data-id="element-1817">
            <div className="flex flex-col md:flex-row items-center gap-6 mb-8" data-id="element-1818">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1819">
                <Smartphone size={32} className="text-primary" data-id="element-1820" />
              </div>
              <div data-id="element-1821">
                <h2 className="text-2xl font-semibold mb-2" data-id="element-1822">Our SMS Number</h2>
                <p className="text-muted-foreground mb-4" data-id="element-1823">
                  Text any TikTok or YouTube link to this number to receive an
                  instant transcript.
                </p>
                <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer w-fit hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-1824">
                  <span className="font-medium" data-id="element-1825">{phoneNumber}</span>
                  {copied ? <Check size={16} className="text-green-500" data-id="element-1826" /> : <Copy size={16} data-id="element-1827" />}
                </div>
              </div>
            </div>
            <div className="space-y-6" data-id="element-1828">
              <section data-id="element-1829">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1830">
                  <MessageSquare size={18} className="text-primary mr-2" data-id="element-1831" />
                  SMS Opt-In Consent
                </h3>
                <div className="bg-secondary/30 p-4 rounded-lg border border-border" data-id="element-1832">
                  <p className="mb-2 font-medium" data-id="element-1833">
                    By texting our number ({phoneNumber}), you agree to:
                  </p>
                  <ul className="space-y-2 text-muted-foreground" data-id="element-1834">
                    <li className="flex items-start gap-2" data-id="element-1835">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1836" />
                      <span data-id="element-1837">
                        Receive automated reply messages containing transcripts
                        and related information
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1838">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1839" />
                      <span data-id="element-1840">
                        Standard message and data rates may apply based on your
                        cellular plan
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1841">
                      <CheckCircle size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1842" />
                      <span data-id="element-1843">
                        You can opt out at any time by replying STOP to any
                        message
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
              <section data-id="element-1844">
                <h3 className="text-xl font-medium mb-3" data-id="element-1845">How It Works</h3>
                <ol className="space-y-4" data-id="element-1846">
                  <li className="flex items-start gap-3" data-id="element-1847">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1848">
                      1
                    </div>
                    <div data-id="element-1849">
                      <p className="font-medium" data-id="element-1850">Text a video link</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1851">
                        Send any TikTok or YouTube URL to {phoneNumber}
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1852">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1853">
                      2
                    </div>
                    <div data-id="element-1854">
                      <p className="font-medium" data-id="element-1855">Wait a moment</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1856">
                        Our AI processes the video and extracts the text
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-1857">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1858">
                      3
                    </div>
                    <div data-id="element-1859">
                      <p className="font-medium" data-id="element-1860">Get your transcript</p>
                      <p className="text-sm text-muted-foreground" data-id="element-1861">
                        Receive the complete transcript via SMS
                      </p>
                    </div>
                  </li>
                </ol>
              </section>
              <section data-id="element-1862">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1863">
                  <FileText size={18} className="text-primary mr-2" data-id="element-1864" />
                  SMS Commands
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1865">
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1866">
                    <p className="font-medium mb-1" data-id="element-1867">STOP</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1868">
                      Opt out of all messages
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1869">
                    <p className="font-medium mb-1" data-id="element-1870">HELP</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1871">
                      Get information about the service
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1872">
                    <p className="font-medium mb-1" data-id="element-1873">/vault</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1874">
                      View your recent transcriptions
                    </p>
                  </div>
                  <div className="p-4 bg-secondary/30 rounded-lg border border-border" data-id="element-1875">
                    <p className="font-medium mb-1" data-id="element-1876">/summary</p>
                    <p className="text-sm text-muted-foreground" data-id="element-1877">
                      Get a condensed version of your transcript
                    </p>
                  </div>
                </div>
              </section>
              <section data-id="element-1878">
                <h3 className="text-xl font-medium mb-3 flex items-center" data-id="element-1879">
                  <AlertCircle size={18} className="text-primary mr-2" data-id="element-1880" />
                  Important Information
                </h3>
                <div className="space-y-3 text-muted-foreground" data-id="element-1881">
                  <p data-id="element-1882">
                    ScribeTok is a utility service that only sends messages in
                    direct response to user requests. We do not send promotional
                    or marketing messages.
                  </p>
                  <p data-id="element-1883">
                    Message frequency depends on your usage. We only respond
                    when you text us a video link or use one of our commands.
                  </p>
                  <p data-id="element-1884">
                    Your carrier's message and data rates may apply. Contact
                    your wireless provider for details about your plan.
                  </p>
                  <p data-id="element-1885">
                    For support issues, please contact us at
                    support@scribetok.com or visit our website.
                  </p>
                </div>
              </section>
            </div>
          </CardContent>
        </Card>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8" data-id="element-1886">
          <a href={smsHref} data-id="element-1887">
            <Button size="lg" className="w-full sm:w-auto" data-id="element-1888">
              <MessageSquare size={16} className="mr-2" data-id="element-1889" />
              Text Now
            </Button>
          </a>
          <Link to="/text" data-id="element-1890">
            <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-1891">
              Back to Main Page
              <ArrowRight size={16} className="ml-2" data-id="element-1892" />
            </Button>
          </Link>
        </div>
        <footer className="text-center text-sm text-muted-foreground" data-id="element-1893">
          <p className="mb-2" data-id="element-1894">
            By using our service, you agree to our{' '}
            <a href="#" className="text-primary hover:underline" data-id="element-1895">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="#" className="text-primary hover:underline" data-id="element-1896">
              Privacy Policy
            </a>
            .
          </p>
          <p data-id="element-1897">© {new Date().getFullYear()} ScribeTok. All rights reserved.</p>
        </footer>
      </div>
    </div>;
}